import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface ListaEntiERPProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const listaEntiERP: Array<ItemVM> = [
  {
    id: 'MM',
    value: 'MM',
  },
  {
    id: 'ALER',
    value: 'ALER',
  },
];

const ListaEntiERPComponent = ({
  disabled,
  required,
  onChange,
  value,
  label = 'Ente ERP',
  error,
  id = 'ente-erp',
}: ListaEntiERPProps): React.ReactElement => {
  const dataList = listaEntiERP;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`${id}-label`}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label || undefined}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {dataList?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListaEntiERPComponent.displayName = 'List enti erp component';

const ListaEntiERP = memo(ListaEntiERPComponent);

export default ListaEntiERP as typeof ListaEntiERPComponent;
